/* eslint-disable react/no-danger */
import { CalendarXIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { Card, HeroLayout } from "../components";
import { useGetConfig } from "../store/use-config";

export const RunOutOfSlots = () => {
  const { t } = useTranslation();
  const config = useGetConfig();

  return (
    <HeroLayout>
      <IntersectionFadeIn className="relative z-20 h-full">
        <div className="mx-auto flex h-full max-w-[800px] items-center justify-center px-4">
          <Card className="flex flex-col items-center text-center">
            <CalendarXIcon className="size-8 text-black" />
            <h1 className="mt-1 mb-4 font-semibold text-2xl">{t("GROUP_ACTIONS_ORDERING.RUN_OUT_OF_SLOTS.TITLE")}</h1>

            <div dangerouslySetInnerHTML={{ __html: config.noSlotsAlert }} />
          </Card>
        </div>
      </IntersectionFadeIn>
    </HeroLayout>
  );
};
